var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EventsListMerchantComponent"},[_c('v-container',[_c('v-row',_vm._l((_vm.listEvents.slice(0, _vm.max)),function(event,key){return _c('v-col',{key:key,attrs:{"cols":_vm.cols}},[_c('EventBoxComponent',{attrs:{"event":event}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }